export const ADD_PENDING_REQUEST = 'ADD_PENDING_REQUEST';
export const CLEAR_PENDING_REQUESTS = 'CLEAR_PENDING_REQUESTS';
